import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    status: false,
    userData: null,
    Authenticated: false,
    user: null,
    userCode: null,
    token: null,
    loginSessionID: null,
    error: null,
    loading: false,
    isLogin: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        isAuthenticate: (state, action) => {
            state.Authenticated = action.payload
        },
        LogOut: (state, action) => {
            state.status = false;
            state.userData = null;
        },
        setSubLoading: (state, action) => {
            state.loading = action.payload;
        },
        setLoginStatus: (state, action) => {
            state.isLogin = action.payload;
        },
    },
});

export const { LogOut, UserLogin, isAuthenticate, setLoginStatus, setIsMultipleCompanyAccess, setSubLoading } = authSlice.actions

export default authSlice.reducer